











import Home from './home.vue'
import AbpBase from "@/lib/abpbase"
import {Component} from "vue-property-decorator"

@Component({
	components:{Home}
})
export default class PatientStatistics extends AbpBase{
	position = 0
	buttons = ['数据统计']
	handleTabRemove(){

	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/patientOut/index.vue